<!-- <mat-dialog-content>
    <section class="w3l-hero-headers-11 p-sticky-md">
        <div class="top-header">
            <div class="d-grid grid-columns-top-3">
                <div class="accounts">
                    <ul>
                        <li></li>
                        <li></li>
                    </ul>
                </div>
                <div class="search">
                  <form action="search-results.html" method="get" style="align-items: flex-start;">

                        <input id="searchn" name="searchn" type="text" [(ngModel)]="patientFName" style="width:30%" (keyup)="retrivePatients()" placeholder="Patient Name">
                        <label style="width: 2%;">  </label>
                        <input id="searchc" name="searchc" type="text" [(ngModel)]="patientCode"style="width:30%" (keyup)="retrivePatients()" placeholder="Patient Code">
                        <label style="width: 2%;">  </label>
                        <input id="searchm" name="searchm" type="text" [(ngModel)]="telMobile"  style="width:35%" (keyup)="retrivePatients()" placeholder="Mobile No.">
                        <label style="width: 8%;">                                   </label>
                  </form>
                </div>
            </div>
        </div>
    </section>

    <table>
        <thead>
            <tr>

                <th style="width: 30%;">Patient Name</th>
                <th style="width: 14%;">Patient ID</th>
                <th style="width: 10%;">Cancer Type</th>
                <th style="width: 30%;">Mobile No.</th>
                <th style="width: 16%;">Choose</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let pa of patientList; let i = index">
              <td data-column="Patient Name">{{pa.patientFName}}</td>
                <td data-column="Patient ID">{{pa.patientCode}}</td>

                <td data-column="Cancer Type">{{pa.cancerID}}</td>
                <td data-column="Mobile No.">{{pa.telMobile}}</td>
                <td data-column="Choose"><button type="button" style="width: 10%;" class="theme-button btn" name="submit" (click)="SelectPatient(pa)">Select</button>
                </td>
            </tr>
        </tbody>
    </table>
</mat-dialog-content>
 -->

<mat-dialog-content class="customer-dialog">

  <!-- Header -->
  <div class="dialog-header"><i class="fa fa-search" aria-hidden="true"></i>
    {{ 'Patient Search' | translate }}
  </div>

  <!-- Search Section -->
  <div class="search-container">
    <mat-form-field >
      <mat-label>Patient Name</mat-label>
      <input matInput [(ngModel)]="patientFName" (keyup)="retrivePatients()">
    </mat-form-field>

    <mat-form-field  >
      <mat-label>{{'Patient Code' | translate}}</mat-label>
      <input matInput [(ngModel)]="patientCode" (keyup)="retrivePatients()">
    </mat-form-field>

    <mat-form-field >
      <mat-label>{{'Mobile No' | translate}}</mat-label>
      <input matInput [(ngModel)]="telMobile" (keyup)="retrivePatients()">
    </mat-form-field>
  </div>

  <!-- Table -->
  <div class="table-container">
    <table class="customer-table">
      <thead>
        <tr matTooltip="Click for sorting" style="cursor: ns-resize;">
          <th >{{'Code' | translate}}</th>
          <th >{{'Name' | translate}}</th>
          <th >{{'Mobile' | translate}}</th>
          <th>{{'Choose' | translate}} </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let sup of patientList">
          <td>{{sup.patientCode}}</td>
          <td>{{sup.patientFName}}</td>
          <td>{{sup.telMobile}}</td>
          <td>
            <button mat-raised-button style="color: white;background-color: rgb(0, 0, 128);"
                    (click)="SelectPatient(sup)">
              {{'Select' | translate}}
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

</mat-dialog-content>
